import React from 'react'
import classNames from 'classnames'
import { Text } from 'components/base'
import Timeago from 'components/Utils/Timeago'
import Avatar from 'components/Utils/Avatar'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

class NotificationRowLayout extends React.Component {
  markAsUnRead = event => {
    event.preventDefault()
    event.stopPropagation()
    this.props.markAsUnread()
  }
  markAsRead = event => {
    event.preventDefault()
    event.stopPropagation()
    this.props.markAsRead()
  }
  render() {
    const {
      avatarProps,
      content,
      timeago,
      aknowledged,
      className,
      markAsRead,
      markAsUnread,
      ...props
    } = this.props
    return (
      <div
        className={classNames(
          'notification-row',
          'pointer',
          'background-shade-100 background-shade-50-on-hover',
          'padding-vertical-medium',
          'border-shade-50 border-bottom-medium font-size-small',
          className
        )}
        {...props}
      >
        <Avatar className="avatar" {...avatarProps} />
        <div className="content line-height-large">{content}</div>
        <div className="timeago">
          <Text.SmallDetail>
            <Timeago date={timeago} />
          </Text.SmallDetail>
        </div>
        <div className="read-status">
          {aknowledged ? (
            <TooltipOnHover
              tooltipContent={'Mark as unread'}
              placement="top"
              id={`mark-notif-as-unread`}
            >
              <div
                className="pointer border-medium radius-largest background-shade-100 border-shade-30"
                style={{ width: 8, height: 8 }}
                onClick={this.markAsUnRead}
              />
            </TooltipOnHover>
          ) : (
            <TooltipOnHover
              tooltipContent={'Mark as read'}
              placement="top"
              id={`mark-notif-as-read`}
            >
              <div
                className="pointer border-medium radius-largest background-red border-red"
                style={{ width: 8, height: 8 }}
                onClick={this.markAsRead}
              />
            </TooltipOnHover>
          )}
        </div>
      </div>
    )
  }
}

export default NotificationRowLayout
